import { useState } from 'react'
import { api } from '@/api/client'

export function BriefDownload({ taskId }: { taskId: string }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  async function download() {
    setBusy(true); setError('')
    try {
      const markdown = await api.get<string>(`/tasks/${taskId}/brief.md`)
      const url = URL.createObjectURL(new Blob([markdown], { type: 'text/markdown;charset=utf-8' }))
      const a = document.createElement('a')
      a.href = url; a.download = `${taskId}-brief.md`
      document.body.appendChild(a); a.click(); a.remove()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch (e) { setError((e as Error).message) }
    finally { setBusy(false) }
  }
  return <div><button type="button" className="sm" disabled={busy} onClick={download} title="Download the latest saved brief, request and rubric">{busy ? 'Downloading…' : 'Download task brief (.md)'}</button>{error && <div className="field-error">{error}</div>}</div>
}
